export default {"src":"/_next/static/media/Merci.8e477ac0.svg","height":418,"width":418,"blurWidth":0,"blurHeight":0};